import { Card, Heading, Inline, LinkButton, Stack, Text, vars } from '@etg/wings';
import { Accordion, Overlay } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { useState } from 'react';
import { isFutureTravelDate } from '../../../../receipt/utils/utils';
import { useOrderDetails } from '../../../containers/OrderDetailsContext';
import DrawerContent from './DrawerContent';

const accordionWrapperStyles = css`
  background-color: ${vars.colors.signal.information.tint};
  border: 1px solid ${vars.colors.signal.information.light};
  border-radius: ${vars.card.borderRadius};
`;

const textsStackStyles = css`
  font-size: 0.875rem;
`;

const contentStackStyles = css`
  padding-top: 8px;
`;

const CarrierVerification = () => {
  const { t } = useTranslation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { tripSegments } = useOrderDetails();

  const lccTripSegments = tripSegments.filter((segment) => segment.lccSupplier === 'ryanair');
  const carrierName = lccTripSegments[0].carrierBookingNumber?.carrierName;
  const isNotificationInitiallyOpen = isFutureTravelDate(lccTripSegments);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <Card className={accordionWrapperStyles}>
        <Accordion
          id="carrier-verification-notification-accordion"
          isInitiallyExpanded={isNotificationInitiallyOpen}
          variant="full-width"
        >
          <Accordion.Header data-testid="carrier-verification-notification-expansion-panel">
            <Heading as="h2" data-testid="carrier-verification-notification-header" level={3}>
              {t('OrderDetails.CarrierVerification.Notification.Title', carrierName)}
            </Heading>
          </Accordion.Header>
          <Accordion.Body>
            <Stack className={contentStackStyles} spacing={8}>
              <Stack className={textsStackStyles} spacing={4}>
                <Text>
                  {t(
                    'OrderDetails.CarrierVerification.Notification.GeneralDescription',
                    carrierName,
                  )}
                </Text>
                <Text>
                  {t('OrderDetails.CarrierVerification.Notification.CTADescription', carrierName)}
                </Text>
              </Stack>
              <Inline>
                <LinkButton
                  aria-controls="carrier-verification-overlay"
                  aria-expanded={isDrawerOpen ? 'true' : 'false'}
                  aria-haspopup="dialog"
                  data-testid="carrier-verification-notification-button"
                  onClick={handleOpenDrawer}
                >
                  {t('OrderDetails.CarrierVerification.Notification.Button')}
                </LinkButton>
              </Inline>
            </Stack>
          </Accordion.Body>
        </Accordion>
      </Card>
      <Overlay.Drawer
        dataTestId="carrier-verification-notification-drawer"
        handleClose={handleCloseDrawer}
        id="carrier-verification-overlay"
        isOpen={isDrawerOpen}
      >
        <Overlay.Header
          onClose={handleCloseDrawer}
          title={t('OrderDetails.CarrierVerification.Drawer.Title')}
        />
        <Overlay.Content data-testid="carrier-verification-notification-drawer-content">
          {carrierName && (
            <DrawerContent carrierName={carrierName} lccTripSegments={lccTripSegments} />
          )}
        </Overlay.Content>
      </Overlay.Drawer>
    </>
  );
};

export default CarrierVerification;
